// ControllersTab.jsx - 控制器Tab组件
import React from 'react';
import { Table, Row, Col, Statistic, Tag } from 'antd';
import { useTranslation } from 'react-i18next';

const COLORS = { primary: '#00d4ff', text: '#ffffff', muted: 'rgba(255,255,255,0.6)', solar: '#f4c542', storage: '#52e8b0', load: '#ff5a7f', grid: '#3a8dde' };
const cardStyle = { background: 'transparent', borderRadius: 8, border: '1px solid rgba(255,255,255,0.1)' };

const fmtTime = (t) => t ? new Date(t).toLocaleString() : '-';

const ControllersTab = ({ controllerStats, controllers, loading, pageSize, statusColor, statusText }) => {
  const { t } = useTranslation();

  return (
    <div style={{ padding: '16px' }}>
      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        {[
          { label: t('stat.total'), value: controllerStats.total, color: COLORS.primary },
          { label: t('status.online'), value: controllerStats.online, color: '#52c41a' },
          { label: t('status.offline'), value: controllerStats.offline, color: COLORS.muted },
          { label: t('status.fault'), value: controllerStats.fault, color: COLORS.load },
        ].map(item => (
          <Col xs={12} sm={8} md={6} key={item.label}>
            <div style={{ ...cardStyle, padding: '12px' }}>
              <div style={{ color: COLORS.muted, fontSize: 11, marginBottom: 4 }}>{item.label}</div>
              <div style={{ color: item.color, fontSize: 18, fontWeight: 'bold' }}>{item.value}</div>
            </div>
          </Col>
        ))}
      </Row>
      <Table
        columns={[
          { title: 'sn', dataIndex: 'sn', key: 'sn', render: t => <span style={{ color: COLORS.primary }}>{t}</span>, width: 110 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.stationName')}</span>, dataIndex: 'station_name', key: 'station_name', render: t => t || '-', width: 130 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.powerKw')}</span>, dataIndex: 'power', key: 'power', render: v => <span style={{ color: COLORS.solar }}>{v ?? 0}</span>, width: 90 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.capacityKwh')}</span>, dataIndex: 'capacity', key: 'capacity', render: v => <span style={{ color: COLORS.storage }}>{v ?? 0}</span>, width: 90 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.status')}</span>, dataIndex: 'sys_status', key: 'sys_status', render: v => <Tag color={statusColor[v]}>{statusText[v] || t('cloud.unknown')}</Tag>, width: 80 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.vendor')}</span>, dataIndex: 'vendor', key: 'vendor', render: t => t || '-', width: 100 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.model')}</span>, dataIndex: 'model', key: 'model', render: t => t || '-', width: 90 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.protocolVersion')}</span>, dataIndex: 'protocol_ver', key: 'protocol_ver', render: t => t || '-', width: 100 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.softVersion')}</span>, dataIndex: 'soft_version', key: 'soft_version', render: t => t || '-', width: 100 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.location')}</span>, dataIndex: 'location', key: 'location', render: t => t || '-', width: 150 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.mqttConnected')}</span>, dataIndex: 'mqtt_connected', key: 'mqtt_connected', render: v => <Tag color={v === 1 ? 'green' : 'default'}>{v === 1 ? '已连接' : '断开'}</Tag>, width: 90 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.cloudConnected')}</span>, dataIndex: 'cloud_connected', key: 'cloud_connected', render: v => <Tag color={v === 1 ? 'green' : 'default'}>{v === 1 ? '已连接' : '断开'}</Tag>, width: 90 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.uptimeS')}</span>, dataIndex: 'uptime_s', key: 'uptime_s', render: v => v != null ? v.toLocaleString() : '-', width: 110 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.timezone')}</span>, dataIndex: 'timezone', key: 'timezone', render: t => t || '-', width: 130 },
          { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.lastOnline')}</span>, dataIndex: 'last_online', key: 'last_online', render: fmtTime, width: 160 },
        ]}
        dataSource={controllers}
        loading={loading}
        rowKey="id"
        pagination={{ pageSize, showSizeChanger: false }}
        style={{ background: 'transparent' }}
        scroll={{ x: 2000 }}
        tableLayout="fixed" />
    </div>
  );
};

export default ControllersTab;
